module.exports = __webpack_public_path__ + "static/img/f1.992db9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/pit/laboratory/f1.png
// module id = Z8XR
// module chunks = 0